import Staff from 'types/staff'
import axiosForGigbaseBiz, { AuthToken } from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
const resource = 'authentications'

export const requests = {
  fetchMine: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<Staff>>(
      mergeURL(resource, 'mine'),
    )
  },
  signin: async (params: {
    identifier: string
    email: string
    password: string
  }) => {
    return await axiosForGigbaseBiz.post<DataResponse<{ token: AuthToken }>>(
      mergeURL(resource, 'signin'),
      params,
    )
  },
  passwordForget: async (params: { email: string }) => {
    return await axiosForGigbaseBiz.post<DataResponse>(
      mergeURL(resource, 'password_forget'),
      params,
    )
  },
  passwordReset: async (params: {
    password: string
    password_confirmation: string
    token: string
  }) => {
    return await axiosForGigbaseBiz.post<DataResponse>(
      mergeURL(resource, 'reset_password'),
      params,
    )
  },
  checkPasswordToken: async (token: string) => {
    return await axiosForGigbaseBiz.post<DataResponse>(
      mergeURL(resource, 'check_password_token'),
      {
        token: token,
      },
    )
  },
  signout: async () => {
    return await axiosForGigbaseBiz.post<DataResponse<void>>(
      mergeURL(resource, 'signout'),
    )
  },
}
